import { ChevronLeft, ChevronRight } from 'lucide-react'
import { cn } from '@/lib/utils'

type Props = {
  page: number
  totalPages: number
  onPageChange: (next: number) => void
}

export function Pagination({ page, totalPages, onPageChange }: Props) {
  const canPrev = page > 0
  const canNext = page < totalPages - 1

  return (
    <nav
      className="flex items-center justify-center gap-3 pt-2"
      aria-label="Paginazione bollette"
    >
      <PageButton
        ariaLabel="Pagina precedente"
        disabled={!canPrev}
        onClick={() => onPageChange(Math.max(0, page - 1))}
      >
        <ChevronLeft className="h-4 w-4" />
      </PageButton>

      <span className="text-sm font-medium text-muted-foreground">
        {page + 1} / {totalPages}
      </span>

      <PageButton
        ariaLabel="Pagina successiva"
        disabled={!canNext}
        onClick={() => onPageChange(Math.min(totalPages - 1, page + 1))}
      >
        <ChevronRight className="h-4 w-4" />
      </PageButton>
    </nav>
  )
}

function PageButton({
  children,
  disabled,
  onClick,
  ariaLabel,
}: {
  children: React.ReactNode
  disabled?: boolean
  onClick: () => void
  ariaLabel: string
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      className={cn(
        'inline-flex h-9 w-9 items-center justify-center rounded-lg transition-colors',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
        disabled
          ? 'cursor-not-allowed bg-muted text-muted-foreground/50'
          : 'bg-secondary text-secondary-foreground hover:bg-secondary/90',
      )}
    >
      {children}
    </button>
  )
}
